import i18n from '../../i18n';

export class Text {
  static get title(): string {
    return i18n._translate('Up next for you', {
      context: 'A heading above a row of cards showing the next workout in a queue.',
    });
  }
}
